import { render, staticRenderFns } from "./ReportsForContentTableView.vue?vue&type=template&id=235f6f0f&"
import script from "./ReportsForContentTableView.vue?vue&type=script&lang=js&"
export * from "./ReportsForContentTableView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports